import { render, staticRenderFns } from "./AddressPanel.vue?vue&type=template&id=03d85a52&"
import script from "./AddressPanel.vue?vue&type=script&lang=ts&"
export * from "./AddressPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports